import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import type { EntityOwnedBusinessInfo } from '@/entity/hooks/use-entity-owned-businesses';
import Fieldset from '../../../fieldset';
type OwnedBusinessesProps = {
  businesses?: EntityOwnedBusinessInfo[];
};
const formatDate = (date: string) => {
  return format(new Date(date), 'MMM d, yyyy');
};
const OwnedBusinesses = t0 => {
  const $ = _c(9);
  const {
    businesses
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.user.vault.businesses"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  if (!businesses?.length) {
    return null;
  }
  let t2;
  if ($[1] !== businesses || $[2] !== t) {
    const sortedBusinesses = [...businesses].sort(_temp);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = [];
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t) {
      t4 = t(_temp2);
      $[5] = t;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t) {
      t5 = business => <div key={business.id} className="flex justify-between py-1.5"><div className="flex flex-col gap-1"><p className="text-label-2 text-primary" id={business.id}>{business.name}</p><div className="flex items-center gap-1"><p className="text-body-2 text-tertiary">{t(_temp3)}</p><p className="text-label-2 text-secondary">{formatDate(business.startTimestamp)}</p></div></div><LinkButton variant="label-2" href={`/businesses/${business.id}`}>{t(_temp4)}</LinkButton></div>;
      $[7] = t;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t2 = <Fieldset fields={t3} title={t4}>{sortedBusinesses.map(t5)}</Fieldset>;
    $[1] = businesses;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default OwnedBusinesses;
function _temp(a, b) {
  return new Date(b.startTimestamp).getTime() - new Date(a.startTimestamp).getTime();
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0.lastActivityAt;
}
function _temp4($_1) {
  return $_1.link;
}